import { render, staticRenderFns } from "./review.vue?vue&type=template&id=1b966a60&scoped=true"
import script from "./review.vue?vue&type=script&lang=js"
export * from "./review.vue?vue&type=script&lang=js"
import style0 from "./review.vue?vue&type=style&index=0&id=1b966a60&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b966a60",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/private/workspaces/smart-life/smart-life-admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b966a60')) {
      api.createRecord('1b966a60', component.options)
    } else {
      api.reload('1b966a60', component.options)
    }
    module.hot.accept("./review.vue?vue&type=template&id=1b966a60&scoped=true", function () {
      api.rerender('1b966a60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/store/review.vue"
export default component.exports